import { useRouter } from "next/router";
import { useRef } from "react";
import Badge from "../Badge";
import { IconButton } from "../Button";
import { useTwilioConversation } from "../Chat/hooks";
import { ChatIcon } from "../Icon";
import styles from "./Header.module.scss";
import cx from "classnames";
import {
  useLock,
  useResponsive,
  useCurrentTrip,
  useManageNavigation,
} from "@/hooks";
import { Chat } from "@/components/Chat";
import { Division } from "@/fetch/gworld";

const ChatIconButton: React.FC<{
  className?: string;
  stickToEnd?: boolean;
}> = ({ className, stickToEnd }) => {
  const router = useRouter();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const {
    totalUnreadConversationCount,
    setIsChatPopOverOpen,
    isChatPopOverOpen,
  } = useTwilioConversation();
  const { isAllowedToNavigate } = useManageNavigation();
  const { isMobile } = useResponsive();
  const { currentTrip } = useCurrentTrip();

  const isInMessagesPage = router.pathname.includes("/social/messages");

  const handleClick = (e: React.MouseEvent) => {
    // Create ripple effect
    const button = buttonRef.current;
    if (button) {
      const rect = button.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const x = e.clientX - rect.left - size / 2;
      const y = e.clientY - rect.top - size / 2;

      const ripple = document.createElement("span");
      ripple.style.cssText = `
        position: absolute;
        width: ${size}px;
        height: ${size}px;
        left: ${x}px;
        top: ${y}px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 50%;
        transform: scale(0);
        animation: ripple 0.6s ease-out;
        pointer-events: none;
      `;

      button.appendChild(ripple);

      setTimeout(() => {
        ripple.remove();
      }, 600);
    }
    if (isMobile) {
      console.log("here");
      setIsChatPopOverOpen?.((state) => !state);

      document.body.style.overflow = "hidden";
    } else {
      // Add small delay to allow animation to be visible
      setTimeout(() => {
        router.push("/social/messages");
      }, 150);
    }
  };

  return !isInMessagesPage &&
    isAllowedToNavigate &&
    // currentTrip?.division !== Division.Tour
    isMobile ? (
    <>
      <IconButton
        ref={buttonRef}
        onClick={handleClick}
        className={cx(
          styles.chatButtonFocus,
          { [styles.stickToEnd]: stickToEnd },
          className
        )}
      >
        <Badge
          badgeContent={totalUnreadConversationCount}
          color="error"
          invisible={!Boolean(totalUnreadConversationCount)}
        >
          <ChatIcon variant="outlined" />
        </Badge>
      </IconButton>
      <Chat
        isOpen={isChatPopOverOpen || false}
        onTogglePopover={() => {
          setIsChatPopOverOpen?.((state) => !state);
        }}
      />
    </>
  ) : (
    <div className={cx({ [styles.stickToEnd]: stickToEnd && isMobile })} />
  );
};

export default ChatIconButton;
